<template>
  <LineChartGenerator
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height"
  />
</template>

<script>
import { Line as LineChartGenerator } from "vue-chartjs/legacy";

// import {
//   Chart as ChartJS,
//   Title,
//   Tooltip,
//   Legend,
//   LineElement,
//   LinearScale,
//   CategoryScale,
//   PointElement
// } from 'chart.js'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Filler,
} from "chart.js";

// ChartJS.register(
//   Title,
//   Tooltip,
//   Legend,
//   LineElement,
//   LinearScale,
//   CategoryScale,
//   PointElement
// )

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
  Filler
);

export default {
  name: "LineChart",
  components: {
    LineChartGenerator,
  },
  props: {
    chartId: {
      type: String,
      default: "area",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 200,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Array,
      default: () => [
        {
          beforeInit(chart) {
            // Get a reference to the original fit function
            const originalFit = chart.legend.fit;

            // Override the fit function
            chart.legend.fit = function fit() {
              // Call the original function and bind scope in order to use `this` correctly inside it
              originalFit.bind(chart.legend)();
              // Change the height as suggested in other answers
              this.height += 24;
            };
          },
        },
      ],
    },
    theChartData: {
      required: true,
    },
  },
  data() {
    return {
      chartData: {
        labels: this.theChartData.labels,
        datasets: [
          {
            label: "Cashin",
            data: this.theChartData.cashin_statisitcs,
            hidden: false,
            backgroundColor: "rgba(225,245,254,.3)",
            pointBackgroundColor: "#FFFFFF",
            pointRadius: 2,
            pointHoverRadius: 3,
            borderWidth: 1,
            radius: 2,
            borderColor: "#00b6fe",
            fill: true,
          },
          {
            label: "Payouts",
            data: this.theChartData.payouts_statistics,
            backgroundColor: "rgba(252,228,236,.3)",
            pointBackgroundColor: "#FFFFFF",
            pointRadius: 2,
            pointHoverRadius: 3,
            borderColor: "#EC407A",
            hidden: false,
            borderWidth: 1,
            radius: 2,
          },
        ],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        lineTension: 0.4,
        plugins: {
          legend: {
            display: true,
            position: "top",
            labels: {
              font: {
                size: 13,
                family: "Poppins",
              },
              padding: 16,
              boxWidth: 12,
              boxHeight: 12,
            },
          },
        },
        scales: {
          xAxes: {
            grid: {
              display: false,
              drawBorder: false,
              drawTicks: true,
              tickColor: "#FFFFFF",
            },
            ticks: {
              display: true,
              font: {
                family: "Poppins"
              },
            },
          },
          yAxes: {
            grid: {
              drawBorder: false,
              drawTicks: true,
              tickColor: "#FFFFFF",
              color: "#DDDDDD",
              borderDash: [5, 5],
              borderDashOffset: 2,
            },
            ticks: {
              display: true,
              font: {
                family: "Poppins"
              },
            },
          },
        },
      },
    };
  },
};
</script>
